import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: easeOut, delay }}
  >
    {children}
  </motion.div>
);

export const MaskReveal = ({ lines, delay = 0, className = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            ease: easeOut,
            delay: delay + i * 0.12,
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
